import { Injector } from '@angular/core';
import { HttpHeaders, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { BHTTPLoader } from './bHTTPLoader';
import { SystemService } from './system.service';
import { BSessionStorage } from './bSessionStorage.service';
import { BLocalStorageService } from './bLocalStorage.service';
import { BTokenService } from './bToken.service';
var BHttp = (function () {
    function BHttp(bHTTPLoader, inj) {
        this.bHTTPLoader = bHTTPLoader;
        this.inj = inj;
        this.timeout = 90000;
        this.isRefreshingToken = false;
        this.tokenSubject = new BehaviorSubject(null);
        this.systemService = new SystemService();
        this.bSessionStorage = new BSessionStorage();
        this.bLocalStorageService = new BLocalStorageService();
        this.bTokenService = new BTokenService();
        this.appProperties = this.systemService.getVal('properties');
    }
    BHttp.prototype.intercept = function (req, next) {
        var _this = this;
        this.requestInterceptor();
        // Pass on the cloned request instead of the original request.
        return next.handle(this.requestOptions(req))
            .timeout(this.timeout)
            .catch(function (error) { return _this.onCatch(error, req, next); })
            .finally(function () {
            _this.onFinally();
        });
    };
    ;
    BHttp.prototype.updateToken = function (error, req, next) {
        var _this = this;
        if (this.appProperties.appAuthenticationStrategy === 'activeDirectory' ||
            this.appProperties.appAuthenticationStrategy === 'localAuth') {
            if (!this.isRefreshingToken) {
                this.isRefreshingToken = true;
                // Reset here so that the following requests wait until the token
                // comes back from the refreshToken call.
                this.tokenSubject.next(null);
                return this.refreshToken()
                    .switchMap(function (tokensObj) {
                    if (tokensObj) {
                        _this.bTokenService.updateTokens(tokensObj);
                        var newToken = tokensObj['accessToken'];
                        _this.tokenSubject.next(newToken);
                        return next.handle(_this.requestOptions(req));
                    }
                    return Observable.throw(new Error('Can\'t refresh the token'));
                })
                    .catch(function (err) { return _this.onCatchError(err); })
                    .finally(function () { return _this.isRefreshingToken = false; });
            }
            else {
                return this.tokenSubject
                    .filter(function (token) { return token != null; })
                    .take(1)
                    .switchMap(function (token) { return next.handle(_this.requestOptions(req)); });
            }
        }
        else {
            return this.onCatchError(error);
        }
    };
    BHttp.prototype.refreshToken = function () {
        var http = this.inj.get(HttpClient);
        var appProperties = this.systemService.getVal('properties');
        var refreshUrl = this.systemService.getAuthUrl() + 'refresh/' +
            appProperties.appDataSource + '/' + appProperties.appName;
        var body = {
            'uuid': this.bLocalStorageService.getValue('uuid'),
            'userKey': this.bSessionStorage.getValue('userObj')['userKey'],
            'refreshToken': this.bSessionStorage.getValue('refreshToken')
        };
        console.log("refresh", refreshUrl);
        return http.post(refreshUrl, body);
    };
    // '/:tenantName/auth/refresh/:datasource/:appName
    /**
     * Request options.
     * @param options
     * @returns {HttpRequest}
     */
    BHttp.prototype.requestOptions = function (req) {
        var headers = req.headers;
        if (req.headers == null) {
            headers = new HttpHeaders();
        }
        req = req.clone({
            url: this.getFullUrl(req.url),
            headers: headers
        });
        return this.addDefaultHeaders(req);
    };
    /**
    * Default options.
    * @param options
    * @returns {HttpHeadedrs}
    */
    BHttp.prototype.addDefaultHeaders = function (req) {
        /**
         * TODO: Add all default Headers over here
         */
        if (!req.headers.has('Access-Control-Allow-Origin')) {
            req.headers = req.headers.set('Access-Control-Allow-Origin', '*');
        }
        if (!req.headers.has('Content-Type')) {
            req.headers = req.headers.set('Content-Type', 'application/json');
        }
        if (!req.headers.has('Accept')) {
            req.headers = req.headers.set('Accept', 'application/json');
        }
        if (!req.headers.has('Authorization')) {
            if (this.appProperties.appAuthenticationStrategy === 'basicAuth') {
                // user id and password hardcoded
                req.headers = req.headers.set('Authorization', 'Basic YmhpdmUtYXJ0LXByb3h5dXNlcjphcnRwcm94eUAxMzU3OSEjJSYoKQ==');
            }
            else if (this.appProperties.appAuthenticationStrategy === 'activeDirectory' ||
                this.appProperties.appAuthenticationStrategy === 'localAuth') {
                if (this.bSessionStorage.getValue('accessToken')) {
                    req.headers = req.headers.set('Authorization', 'Bearer ' + this.bSessionStorage.getValue('accessToken'));
                }
            }
        }
        return req;
    };
    /**
     * Build API url.
     * @param url
     * @returns {string}
     */
    BHttp.prototype.getFullUrl = function (url) {
        // return full URL to API here
        return url;
    };
    /**
     * Request interceptor.
     */
    BHttp.prototype.requestInterceptor = function () {
        this.bHTTPLoader.isHTTPRequestInProgress(true);
    };
    /**
     * Response interceptor.
     */
    BHttp.prototype.responseInterceptor = function () {
        this.bHTTPLoader.isHTTPRequestInProgress(false);
    };
    /**
      * Error handler.
      * @param error
      * @param caught
      * @returns {ErrorObservable}
      */
    BHttp.prototype.onCatch = function (error, req, next) {
        if (error instanceof HttpErrorResponse) {
            if (error.status === 403 && error.error.message === 'jwt expired') {
                return this.updateToken(error, req, next);
            }
            else {
                return this.onSubscribeError(error);
            }
        }
        else {
            return this.onSubscribeError(error);
        }
    };
    /**
     * onSubscribeError
     * @param error
     */
    BHttp.prototype.onSubscribeError = function (err) {
        this.bHTTPLoader.alertError(err);
        return this.onCatchError(err);
    };
    /**
     * onFinally
     */
    BHttp.prototype.onFinally = function () {
        this.responseInterceptor();
    };
    BHttp.prototype.onCatchError = function (error) {
        return Observable.throw(error);
    };
    return BHttp;
}());
export { BHttp };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bHTTP.ts.pre-build-optimizer.js